import React from 'react';
import { Avatar, Button, Separator, UI } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import i18n from '@gik/i18n';
import { useInkind } from '@gik/api/inkinds/inkind';
import { copyWithNotification } from '@gik/core/utils/LinkUtils';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

export interface IContactPageOrganizersProps {
  inkindRouteId: string;
}

export function ContactPageOrganizers({ inkindRouteId }: IContactPageOrganizersProps): React.ReactElement {
  const bem = bemBlock('contact-page-organizers');
  const { data: inkindPage } = useInkind(inkindRouteId);
  const { t } = useTranslation();
  const isMd = useBreakpoint(Breakpoint.MD);

  const ownerAndOrganizers = [inkindPage?.owner, ...inkindPage?.organizers].filter(v => v);

  return (
    <div className={bem('content')}>
      {ownerAndOrganizers.map((organizer, index) => {
        const emailComponent = (
          <Button
            variant="primary-link"
            onClick={() => copyWithNotification(organizer.email, t(translationKeys.emailCopied))}
          >
            {organizer.email}
          </Button>
        );
        const pageOwnerComponent = organizer.isOwner && (
          <span className={bem('owner')}>{t(translationKeys.pageOwner)}</span>
        );
        return (
          <div className={bem('contact-line')} key={organizer.email}>
            <main>
              <Avatar className={bem('avatar')} imageUrl={`${organizer.imgThumbSmall}`} circle />
              <div className={bem('contact-line-content')}>
                <div className={bem('top')}>
                  <span className={bem('name')}>{organizer.name}</span>
                  <div className={bem('filler')} />
                  {!isMd ? pageOwnerComponent : emailComponent}
                </div>
                {isMd ? pageOwnerComponent : emailComponent}
              </div>
            </main>
            {index < ownerAndOrganizers.length - 1 && <Separator variant="default" size="sm" />}
          </div>
        );
      })}
    </div>
  );
}

export function openContactPageOrganizersModal(inkindRouteId: string): void {
  const bem = bemBlock('contact-page-organizers-modal');

  UI.info(() => <ContactPageOrganizers inkindRouteId={inkindRouteId} />, {
    title: i18n.t(translationKeys.modalTitle),
    padding: false,
    closable: true,
    className: bem(),
    centeredTitle: false,
    okText: i18n.t(translationKeys.okText),
  });
}
